export default __webpack_public_path__ + "static/media/503-error.18db9977.svg";